import { Grid } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import GridTextField from 'components/GridTextField';
import HeaderDetails from 'components/HeaderDetails';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from 'store';
import {
  removeCategory, saveCategory
} from 'store/categories/categoriesActions';
import { CategoriesActionTypes } from 'store/categories/categoriesTypes';





const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  content: {
    height: '100%',
    overflowY: 'scroll',
    padding: theme.spacing(2),
  },
  input: {
    margin: theme.spacing(1),
  },
  marginRight: {
    marginRight: theme.spacing(1),
  },
}));

interface Form {
  name: string;
  type: string;
  active: boolean;
}

const emptyForm: Form = {
  name: '',
  type: 'incomes',
  active: true,
};

export default function CategoriesDetails() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { savingCategory, removingCategory, isEditing, originalData } =
    useSelector(({ categoriesState }: StoreState) => ({
      savingCategory: categoriesState.savingCategory,
      removingCategory: categoriesState.removingCategory,
      isEditing: categoriesState.selectedIndex !== null,
      originalData:
        categoriesState.selectedIndex !== null
          ? categoriesState.categories[categoriesState.selectedIndex]
          : null,
    }));

  const [isOpenModalRemove, setOpenModalRemove] = useState(false);
  const openModalRemove = () => setOpenModalRemove(true);
  const closeModalRemove = () => setOpenModalRemove(false);

  const form = useForm<Form>({
    defaultValues: originalData || emptyForm,
  });

  const type = form.watch('type');
  const active = form.watch('active');

  useEffect(() => {
    form.register({ name: 'type' });
    form.register({ name: 'active' });
  }, [form]);

  const onClose = () => {
    dispatch({ type: CategoriesActionTypes.EDITING_CANCEL });
  };

  const onSubmitForm = async () => {
    await form.triggerValidation();
    if (Object.entries(form.errors).length) {
      return;
    }
    const data = form.getValues();
    dispatch(saveCategory(data));
    form.reset(emptyForm);
  };

  const onClickConfirmRemoveCategory = () => {
    closeModalRemove();
    dispatch(removeCategory());
  };

  return (
    <Box className={classes.container}>
      <HeaderDetails
        title={isEditing ? 'Editando cadastro' : 'Novo cadastro'}
        onClose={onClose}
      />
      <div className={classes.content}>
        <Grid container spacing={2}>
          <GridTextField
            label="Nome"
            name="name"
            gridSize={12}
            inputRef={form.register({
              required: 'Preencha este campo',
            })}
            errorMessage={form.errors?.name?.message}
          />
          <GridTextField
            label="Tipo"
            name="type"
            gridSize={12}
            options={[
              { name: `${'Receitas'}`, value: 'incomes' },
              { name: 'Despesas', value: 'expenses' },
            ]}
            onChange={(e: any) => form.setValue('type', e.target.value)}
            value={type}
            disabled={isEditing}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={active}
                onChange={() => form.setValue('active', !active)}
              />
            }
            label="Ativo"
          />
        </Grid>
      </div>

      <Box>
        <Divider />
        <Box m={2}>
          <Button
            onClick={onSubmitForm}
            size="large"
            color="primary"
            variant="contained"
            disabled={savingCategory}
            className={classes.marginRight}
          >
            <SaveAltIcon className={classes.marginRight} />
            {savingCategory ? 'AGUARDE...' : 'SALVAR'}
          </Button>
          <Button
            onClick={openModalRemove}
            size="large"
            disabled={!isEditing}
            className={classes.marginRight}
          >
            <DeleteIcon className={classes.marginRight} />
            {removingCategory ? 'AGUARDE...' : 'EXCLUIR'}
          </Button>
        </Box>
      </Box>

      <Dialog open={isOpenModalRemove} onClose={closeModalRemove}>
        <DialogTitle>Excluir este cadastro?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Esta ação não poderá ser desfeita.
            <br />
            Tem certeza que deseja remover este cadastro?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={removingCategory}
            onClick={closeModalRemove}
            color="primary"
          >
            Não
          </Button>
          <Button
            disabled={removingCategory}
            onClick={onClickConfirmRemoveCategory}
            color="primary"
            autoFocus
          >
            SIM
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
